module.exports = __webpack_public_path__ + "img/mobile-47.3d349e4a.png";